<template lang="pug">
w-input.f-password(
  v-bind=`{ value, label, required }`
  ref='input'
  type='password'
  label='password'
  @input='input'
)
</template>

<script lang="js">
import WInput, { mixin } from '@/widgets/w-input'

export default {
  name: 'PasswordField',
  mixins: [ mixin ],
  components: { WInput },
  props: {
    label: {
      type: String,
      default: 'password'
    },
    required: {
      type: Boolean,
      default: true
    },
    minLength: {
      type: Number,
      default: 8
    }
  },
  data() {
    return {
    }
  },
  created() {},
  mounted() {},
  methods: {},
  computed: {}
}
</script>

<style lang="scss">
.f-password {

}
</style>
